const Highcharts = require("highcharts");
const StockHighcharts = require("highcharts/highstock");
import { alpha, useTheme } from "@material-ui/core";
import { useMemo } from "react";
import { THEME_MODE } from "src/config/constants";
import { COLOR_ARRAY } from "src/config/styleConfig";

export const defaultYAxisConfig = {
  labels: {
    enabled: false,
  },
  title: {
    text: undefined,
  },
  gridLineWidth: 0,
};

const defaultOption = (theme) => ({
  chart: {
    backgroundColor: "transparent",
    style: {
      fontFamily: "'Fira Sans', sans-serif",
      fontSize: "12px",
    },
  },
  title: {
    style: {
      color: theme.palette.primary.main,
      fontSize: "16px",
    },
  },
  yAxis: {
    gridLineColor: theme.palette.type === THEME_MODE.DARK ? "#263343" : "#D7DFEC",
    lineColor: alpha(theme.palette.primary.main, 0.1),
    tickColor: alpha(theme.palette.primary.main, 0.1),
    title: {
      style: {
        color: theme.palette.text.primary,
      },
    },
    labels: {
      style: {
        color: theme.palette.text.primary,
      },
    },
  },
  xAxis: {
    gridLineColor: theme.palette.type === THEME_MODE.DARK ? "#263343" : "#D7DFEC",
    tickColor: alpha(theme.palette.primary.main, 0.1),
    lineColor: alpha(theme.palette.primary.main, 0.1),
    title: {
      style: {
        color: theme.palette.text.primary,
      },
    },
    labels: {
      style: {
        color: theme.palette.text.primary,
      },
    },
  },
  legend: {
    itemStyle: {
      color: theme.palette.text.secondary,
    },
    itemHoverStyle: {
      color: theme.palette.primary.main,
    },
    itemHiddenStyle: {
      color: theme.mode === THEME_MODE.DARK ? "#7a7a7a" : "#cccccc",
    },
  },
  plotOptions: {
    bar: {
      dataLabels: {
        style: {
          color: theme.palette.text.secondary,
          textOutline: "none",
        },
      },
    },
  },
  colors: COLOR_ARRAY,
  time: {
    useUTC: false,
  },
  tooltip: {
    backgroundColor: {
      linearGradient: [0, 0, 0, 60],
      stops: [
        [0, "#FFFFFF"],
        [1, "#E0E0E0"],
      ],
    },
  },
});

export default function BaseChartStyle() {
  const theme = useTheme();

  useMemo(() => {
    Highcharts.setOptions(defaultOption(theme));
    StockHighcharts.setOptions(defaultOption(theme));
  }, [theme]);

  return null;
}
